// import { formatDate } from "@/utils";
import ColorInternarRequest from "@/components/functionals/ColorInternarRequest";
import RequestType from "@/components/requests/internal/RequestType.vue";
import GetRate from "@/components/requests/internal/GetRate.vue";
import ColorInternarStatus from "@/components/functionals/ColorInternarStatus";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";

export const getActions = (self) => {
  //console.log("getActions: ", self, "\n currentUser: ", self.currentUser);
  return {
    new: [
      {
        icon: "el-icon-view",
        label: "Ver Detalle",
        command: "details"
      },
      {
        icon: "el-icon-check",
        label: "Asignar Responsable",
        command: "set",
        condition: function () {
          return self.currentUser.IsSupervisor;
        }
      },
      {
        icon: "el-icon-open",
        label: "Cambiar Dirección TI",
        command: "changesDirectionIT",
        condition: () => {
          return (
            (self.currentUser.Roles.some((rol) => rol.Id == 13) &&
              self.selectedDirection == 42) ||
            (self.currentUser.Roles.some((rol) => rol.Id == 37) &&
              self.selectedDirection == 42)
          );
        }
      },
      {
        icon: "el-icon-plus",
        label: "Agregar Comentarios",
        command: "addComment"
      },
      {
        icon: "el-icon-remove",
        label: "Cancelar",
        command: "cancell",
        condition: function ({ CreateById }) {
          /*
          console.log(
            "getActions condition: ",
            self,
            "\n currentUser: ",
            self.currentUser
          );
          */
          if (
            CreateById == self.currentUser.EmployeeId ||
            self.currentUser.Roles.some((r) => r.Id === 37)
          ) {
            return true;
          }
          return false;
        }
      }
    ],
    progress: [
      {
        icon: "el-icon-view",
        label: "Ver Detalle",
        command: "details"
      },
      {
        icon: "el-icon-s-tools",
        label: "Cambiar progreso",
        command: "setProgress",
        condition: () => {
          return (
            (self.currentUser.Roles.some((rol) => rol.Id == 13) &&
              self.selectedDirection == 42) ||
            (self.currentUser.Roles.some((rol) => rol.Id == 37) &&
              self.selectedDirection == 42)
          );
        }
      },
      {
        icon: "el-icon-open",
        label: "Cambiar Dirección TI",
        command: "changesDirectionIT",
        condition: () => {
          return (
            (self.currentUser.Roles.some((rol) => rol.Id == 13) &&
              self.selectedDirection == 42) ||
            (self.currentUser.Roles.some((rol) => rol.Id == 37) &&
              self.selectedDirection == 42)
          );
        }
      },
      {
        icon: "el-icon-plus",
        label: "Agregar Comentarios",
        command: "addComment"
      },
      {
        icon: "el-icon-check",
        label: "Reasignar Responsable",
        command: "set",
        condition: function () {
          return self.currentUser.IsSupervisor;
        }
      },
      {
        icon: "el-icon-remove",
        label: "Cancelar",
        command: "cancell",
        condition: function ({ CreateById }) {
          if (
            CreateById == self.currentUser.EmployeeId ||
            self.currentUser.Roles.some((r) => r.Id === 37)
          ) {
            return true;
          }
          return false;
        }
      },
      {
        icon: "el-icon-error",
        label: "Cerrar",
        command: "close",
        condition: function ({ ResponsableID }) {
          if (
            ResponsableID == self.currentUser.EmployeeId ||
            self.currentUser.IsSupervisor
          ) {
            return true;
          }
          return false;
        }
      }
    ],
    closed: [
      {
        icon: "el-icon-view",
        label: "Ver Detalle",
        command: "details"
      },
      {
        icon: "el-icon-picture",
        label: "Ver Evidencias",
        command: "evidences"
      },
      {
        icon: "el-icon-plus",
        label: "Agregar Comentarios",
        command: "add"
      },
      {
        icon: "el-icon-back",
        label: "Reabrir",
        command: "reopen",
        condition: function ({ CreateById }) {
          if (
            CreateById == self.currentUser.EmployeeId ||
            self.currentUser.Roles.some((r) => r.Id === 37)
          ) {
            return true;
          }
          return false;
        }
      },
      {
        icon: "el-icon-remove",
        label: "Cancelar",
        command: "cancell",
        condition: function ({ CreateById }) {
          if (
            CreateById == self.currentUser.EmployeeId ||
            self.currentUser.Roles.some((r) => r.Id === 37)
          ) {
            return true;
          }
          return false;
        }
      }
    ],
    completed: [
      {
        icon: "el-icon-view",
        label: "Ver Detalle",
        command: "details"
      },
      {
        icon: "el-icon-plus",
        label: "Agregar Comentarios",
        command: "addComment"
      }
    ],
    all: [
      {
        icon: "el-icon-view",
        label: "Ver Detalle",
        command: "details"
      }
    ],
    canceled: [
      {
        icon: "el-icon-view",
        label: "Ver Detalle",
        command: "details"
      }
    ]
  };
};

export const COLUMNS = [
  {
    prop: "Id",
    label: "No",
    minWidth: 80,
    fixed: true,
    sortable: true,
    formatter: ColorInternarRequest
  },
  {
    prop: "CreatedAt",
    label: "Fecha",
    minWidth: 120,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "corta",
    label: "Descripcion",
    sortable: true,
    minWidth: 250
    //formatter: (row) => { console.log(row.corta )  }
  },
  {
    prop: "TipoSolicitud",
    label: "Tipo de Solicitud",
    minWidth: 250,
    sortable: true,
    formatter: RequestType
  },
  {
    prop: "SlaDaysToResponse",
    label: "Sla (dias)",
    sortable: true,
    minWidth: 120
  },
  {
    prop: "DiasRetrasadosSla",
    label: "Atraso",
    sortable: true,
    minWidth: 120
  },
  {
    prop: "Reopen",
    label: "Reabierta?",
    minWidth: 120,
    sortable: true,
    formatter: (props) => {
      if (props.Reopen) {
        return "SI";
      }
      return "NO";
    }
  },
  {
    prop: "Valoracion",
    label: "Calificacion",
    minWidth: 200,
    sortable: true,
    formatter: GetRate
  },
  {
    prop: "ComentarioValoracion",
    label: "Comentario Calificacion",
    sortable: true,
    minWidth: 250
  },
  {
    prop: "Responsable",
    label: "Responsable",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "ResponsableImage"
    }
  },
  {
    prop: "Supervisor",
    label: "Supervisor",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "SupervisorImage"
    }
  },
  {
    prop: "CreateBy",
    label: "Creado Por",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "CreatorImage"
    }
  },
  {
    prop: "StatusSlaDescripcion",
    label: "Cumplimiento",
    minWidth: 130,
    sortable: true,
    formatter: ColorInternarStatus
  }
];
